module.exports = __webpack_public_path__ + "img/features_img_pos.55d865c6.png";